/*
  pricingConfig.js — single source of truth for Axigon AI pricing plans.
  Imported by both LandingPage.js and PricingPage.js.
*/

export const PLANS = [
  {
    id: 'free',
    name: 'FREE',
    price: '₹0',
    period: '',
    priceNote: 'Free forever',
    desc: 'For individuals who want to explore Axigon.',
    features: [
      '5 AI conversations/month',
      'Financial health score',
      'Document upload (1 file)',
    ],
    cta: 'Get started free',
    highlight: false,
    badge: null,
  },
  {
    id: 'pro',
    name: 'PRO',
    price: '₹299',
    period: '/month',
    priceNote: 'Billed monthly',
    desc: 'For professionals who want full control of their finances.',
    features: [
      'Unlimited AI finance conversations',
      'Document uploads (up to 50)',
      '80C alerts & advance tax reminders',
      'Financial health score & summaries',
      'Priority support',
    ],
    cta: 'Start free trial',
    highlight: true,
    badge: 'Most popular',
  },
  {
    id: 'expert',
    name: 'EXPERT CONNECT',
    price: '₹999',
    period: '/matter',
    priceNote: 'No subscription required',
    desc: 'Connect with a verified CA or financial expert.',
    features: [
      'Everything in Pro',
      'Connect with a verified CA or Advocate',
      '48-hour response SLA',
      'Secure document sharing',
      'Private matter tracking',
    ],
    cta: 'Connect now',
    highlight: false,
    badge: null,
  },
];
